<template>
    <div
        v-show="visible"
        id="tothetop-wrapper"
    >
        <v-icon
            large
            v-scroll="onScroll"
            @click="toTop"
        >
            {{ icons.mdiChevronUp }}
        </v-icon>
    </div>
</template>

<script>
import { mdiChevronUp } from '@mdi/js';

export default {
    name: 'BnToTheTopBtn',
    data() {
        return {
            icons: {
                mdiChevronUp,
            },
            visible: false,
        };
    },
    methods: {
        onScroll() {
            const top = (
                window.pageYOffset
                || document.documentElement.offsetTop
                || 0
            );

            this.visible = top > 500;
        },
        toTop() {
            this.$vuetify.goTo(0);
        },
    },
};
</script>

<style scoped>
    #tothetop-wrapper {
        position:fixed;
        bottom: 20px;
        right: 35px;
        padding: 10px;
        border-radius: 50%;
        background-color: white;
        box-shadow: 0 0 3px #d6d6d6;
    }
</style>
